import { type FC, PropsWithChildren } from 'react';

import { ConnectSurface } from '@/components/Pretzel/ConnectSurface';

export const DebugSurface: FC<PropsWithChildren> = ({ children }) => {
  return <ConnectSurface>{children}</ConnectSurface>;
};
